/*
  Header top bar -- hover-to-open dropdowns (desktop).

  Bound to [data-htb-dropdown], which BOTH the currency selector and any custom block with a menu
  carry, so the two share one open/close implementation (hover intent, close delay, bridge, focus
  handling) rather than forking.

  The theme's own <localization-form> element (assets/secondary.js) already wires up the click
  toggle, outside-click close, Escape handling and the form submit on option click. This file only
  ADDS a hover trigger on top of that; it deliberately does not replace or unbind any of it, so the
  click behaviour keeps working as a fallback.

  Open/close is driven through the same `hidden` attribute + aria-expanded pair the element already
  uses, so the existing transitions are untouched.

  Hover-intent: leaving the trigger starts a short timer instead of closing immediately, and an
  `is-open` class exposes a CSS bridge across the visual gap between trigger and dropdown, so moving
  the cursor down into the panel does not snap it shut.
*/
(function () {
  // Closes every OTHER open dropdown. Belt-and-braces on top of the instant mouseleave close:
  // however the cursor arrives (a fast jump between triggers, a click, keyboard focus), only one
  // panel can ever be open at a time.
  function closeOthers(current) {
    document.querySelectorAll('[data-htb-dropdown].is-open').forEach(function (other) {
      if (other === current) return;
      var p = other.querySelector('.header-top-bar__disclosure-list-wrapper');
      var b = other.querySelector('.header-top-bar__disclosure-button');
      if (p) p.setAttribute('hidden', '');
      if (b) b.setAttribute('aria-expanded', 'false');
      other.classList.remove('is-open');
    });
  }

  function setup(group) {
    if (group.dataset.htbHoverReady === 'true') return;

    var button = group.querySelector('.header-top-bar__disclosure-button');
    var panel = group.querySelector('.header-top-bar__disclosure-list-wrapper');
    if (!button || !panel) return;

    group.dataset.htbHoverReady = 'true';

    function open() {
      closeOthers(group);
      panel.removeAttribute('hidden');
      button.setAttribute('aria-expanded', 'true');
      group.classList.add('is-open');
    }

    function close() {
      panel.setAttribute('hidden', '');
      button.setAttribute('aria-expanded', 'false');
      group.classList.remove('is-open');
    }

    // Hover is the primary trigger, and the close is IMMEDIATE -- no timeout. A delay left the
    // outgoing panel on screen while the next one opened, so moving between the currency and menu
    // triggers showed both at once.
    //
    // The travel from trigger down into the panel is still safe without a delay: the panel is a DOM
    // descendant of the group, so moving into it never leaves the group, and the CSS bridge
    // ([data-htb-dropdown].is-open .header-top-bar__disclosure::after) covers the visual gap
    // between them. mouseleave therefore only fires on a true exit of the whole trigger+panel
    // group, which is exactly when it should close.
    group.addEventListener('mouseenter', open);
    group.addEventListener('mouseleave', close);

    // Keyboard parity: focusing into the group opens it, leaving it entirely closes it.
    group.addEventListener('focusin', open);
    group.addEventListener('focusout', function (event) {
      if (!group.contains(event.relatedTarget)) close();
    });

    // Keep the class in sync when the theme's own click handler toggles the panel, so the CSS
    // bridge and the hover state never disagree.
    new MutationObserver(function () {
      group.classList.toggle('is-open', !panel.hasAttribute('hidden'));
    }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-htb-dropdown]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor re-renders the section without a full page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
